import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-test-subtract',
  templateUrl: './test-subtract.component.html',
  styleUrls: ['./test-subtract.component.css']
})
export class TestSubtractComponent implements OnInit {

  @Input() a!: number;
  @Input() b!: number;

  constructor() { }

  ngOnInit(): void {
  }

}
